import React from 'react';
import { graphql } from 'gatsby';
import Container from '@atoms/Container';
import SvgSafeGatsbyImage from '@atoms/SvgSafeGatsbyImage';
import paddingDefault from '@utils/paddingDefault';
import { colors } from '../primitives/colors';
// not in use.
const InsurerGrid = ({ data }) => {
    const { insurers } = data;

    return (
        <section css={paddingDefault()}>
            <Container>
                <ul css={styles.gridWrap}>
                    {insurers.map(insurer => (
                        <li css={styles.gridItem} key={insurer.name}>
                            {!!insurer.logo && (
                                <SvgSafeGatsbyImage css={styles.insurerLogo} image={insurer.logo} alt={insurer?.logo?.title} />
                            )}
                            <div css={styles.insurerWrap}>
                                <h3 css={styles.insurerName}>{insurer.name}</h3>
                                <div css={styles.dividerWrap}>
                                    <div css={styles.divider} />
                                </div>
                                <p css={styles.excerpt}>{insurer.excerpt}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </Container>
        </section>
    )
};

const styles = {
    excerpt: {
        fontSize: "1.125rem",
        lineHeight: "1.5rem"
    },
    insurerWrap: {
        paddingLeft: "1rem",
        paddingRight: "1rem"
    },
    divider: {
        width: "3rem",
        height: "1px", backgroundColor: colors.primaryGreen
    },
    dividerWrap: {
        marginBottom: "1rem"
    },
    gridWrap: {
        display: "grid",
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        gap: "2.5rem",
        "@media (min-width: 768px)": {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
        },
        "@media (min-width: 1024px)": {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            gap: "2.25rem"
        }
    },
    gridItem: {
        paddingLeft: "0.5rem",
        paddingRight: "0.5rem",
        paddingTop: "0.75rem",
        paddingBottom: "2.5rem",
        flex: "0 1 auto",
        width: "100%",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
    },
    insurerLogo: {
        marginBottom: "1rem",
        width: "100%",
        aspectRatio: "12 / 10"
    },
    insurerName: {
        marginBottom: "0.25rem",
        fontSize: "1.5rem",
        lineHeight: "2rem", color: colors.primaryOrange
    }
};

export const query = graphql`
  fragment InsurerGridData on CmsPageBuilderBlocks {
    insurer_grid {
      insurers {
        name
        excerpt
        logo {
          filename
          title
          url
          contentStackAsset(width: 280)
        }
      }
    }
  }
`;

export default InsurerGrid;
